import type {
	BreakpointRange,
	BaseDataItem,
	WRichTextDefinition,
	Style,
	Component,
	VectorImageData,
	Image,
} from '@wix/thunderbolt-becky-types'
import { ResolvedSVGItem } from '@wix/thunderbolt-catharsis'
import { CONTAINER_TYPES } from '@wix/thunderbolt-commons'

export const TPA_COMPONENTS = new Set<string>([
	'TPASection',
	'TPAMultiSection',
	'TPAWidget',
	'TPAGluedWidget',
	'tpaWidgetNative',
])

export const isBreakpointRange = (item?: BaseDataItem): item is BreakpointRange => item?.type === 'BreakpointRange'
export const isStyledText = (item?: BaseDataItem): item is WRichTextDefinition['data'] => item?.type === 'StyledText'
export const isVectorImage = (item?: BaseDataItem): item is VectorImageData => item?.type === 'VectorImage'
export const isStylable = (style?: Style) => {
	const properties = style?.style?.properties
	return properties && ('$st-css' in properties || 'st-css' in properties)
}
export const isRichTextComponent = (component: Component) =>
	component.componentType === 'WRichText' || component.componentType === 'MediaRichText'

export const isTpaComponent = (component: Component) => TPA_COMPONENTS.has(component.componentType)
export const isContainer = (componentType: string) => componentType in CONTAINER_TYPES

export const isSVGItem = (item: any): item is ResolvedSVGItem => item.type === 'SVGItem'
export const isImage = (item: any): item is Image => item.type === 'Image'
